import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Bell, User, Menu, ChevronDown } from "lucide-react";
import { BASE_URL } from "../../constant/constant";
import { useNavigate } from "react-router-dom";

const TopBar = ({ onToggleSidebar, sidebarOpen, isMobile = false, currentPageTitle = null }) => {
  const { user, role } = useSelector((state) => state.auth);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const userName = user?.firstName + user?.lastName || user?.email || "User";

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="shadow-sm border-b border-gray-200 px-4 md:px-6 py-4 m-2 md:m-4 rounded-lg"
      style={{
        background: "linear-gradient(to right, #1E6C56, #FFB800)",
      }}
    >
      <div className="flex items-center justify-between">
        {/* Left Side - Hamburger Menu and Welcome Message */}
        <div className="flex items-center gap-2 md:gap-4">
          <button
            onClick={onToggleSidebar}
            className="p-2 rounded-lg hover:bg-gray-100/30 transition-colors"
            aria-label="Toggle sidebar"
          >
            <Menu className="w-5 h-5 text-white" />
          </button>
          <h1 className="text-lg md:text-xl font-semibold text-white truncate">
            {currentPageTitle ? (
              currentPageTitle
            ) : isMobile ? (
              `Hi, ${userName.split(" ")[0]}!`
            ) : (
              `Welcome, ${userName}!`
            )}
           
          </h1>
        </div>

        {/* Right Side - Notifications and User */}
        <div className="flex items-center gap-2 md:gap-4">
         {/* <div className="relative border-2 border-white/50 rounded-full p-1" >
            <Bell className="w-4 h-4 md:w-4 md:h-4 text-white cursor-pointer hover:text-gray-100 transition-colors" />
            <div className="absolute -top-1 -right-1 w-2 h-2 md:w-3 md:h-3 bg-red-500 rounded-full"></div>
          </div> */}

          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setShowUserDropdown(!showUserDropdown)}
              className="flex items-center gap-2 md:gap-3 hover:bg-white/10 rounded-lg p-2 transition-colors"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white/30 rounded-full flex items-center justify-center border-2 border-white/50">
                {user?.profilePicture ? (
                  <img
                    src={`${BASE_URL}${user.profilePicture}`}
                    alt="User"
                    className="w-6 h-6 md:w-7 md:h-7 rounded-full object-cover"
                  />
                ) : (
                  <User className="w-4 h-4 md:w-5 md:h-5 text-white" />
                )}
              </div>
              <div className="flex flex-col items-start">
                <span className="text-white font-medium text-sm md:text-base">
                  {user?.firstName || "User"}
                </span>
                <span className="text-white/80 text-xs md:text-sm capitalize">
                  {role || "Admin"}
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;